import React from "react";
import Skeleton from "./Skeleton";

const EventItemLoader = () => {
  return (
    <div className="border rounded-md h-[350px]">
      <Skeleton height={200} width={"100%"} />
      <div className="h-full space-y-4 p-5">
        <Skeleton height={25} width={"100%"} />
        <div className="space-y-2">
          <Skeleton height={13} width={"100%"} />
          <Skeleton height={13} width={"100%"} />
          <Skeleton height={13} width={"60%"} />
        </div>
      </div>
    </div>
  );
};

export default EventItemLoader;
